import styled from 'styled-components'
import { Button, SkeletonElement, theme } from '@notino/react-styleguide'
import RenderPrice from '../../RenderPrice/RenderPrice'
// styles
import {
	NotinoBodyRegular,
	NotinoLabelRegular400,
	NotinoLabelRegular500,
	NotinoLabelSmall400,
	NotinoTitleMedium,
	resetButtonStyles,
	resetListStyles
} from '../../../styles/helpers'

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0;
`

export const Title = styled.h2`
	${NotinoTitleMedium};
	color: ${theme.color.text.primary};
	margin: 0;
`

export const Description = styled.p`
	${NotinoBodyRegular};
	color: ${theme.color.text.secondary};
	margin: 8px 0 20px;
`

export const List = styled.ul`
	${resetListStyles};
	margin: 0;
	display: flex;
	flex-direction: column;
`

export const ListItemGroup = styled.li`
	padding: 0 0 12px;
	margin: 0;

	&:not(:last-child) {
		border-bottom: 1px solid ${theme.color.border.divider};
		margin-bottom: 12px;
	}
`

export const ListItem = styled.div`
	display: flex;
	gap: 12px;
	align-items: flex-start;
`

export const ServiceImageWrapper = styled.div`
	flex-shrink: 0;
	width: 72px;
	height: 72px;
	overflow: hidden;
	border-radius: 4px;

	/* Override AppContainer img { width: 100% } — size is constrained by this wrapper. */
	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		display: block;
	}
`

export const ServiceImage = styled.img<{ $disabled?: boolean }>`
	opacity: ${({ $disabled }) => ($disabled ? 0.6 : 1)};
`

export const ServiceImageFallback = styled.div`
	width: 100%;
	height: 100%;
	background: ${theme.color.background.tertiary};
`

export const ListItemBody = styled.div`
	display: flex;
	flex: 1;
	flex-direction: column;
`

export const ListItemHeader = styled.div`
	display: flex;
	gap: 12px;
	justify-content: space-between;
`

export const ListItemMain = styled.div<{ $disabled?: boolean }>`
	display: flex;
	flex-direction: column;
	min-width: 0;
	opacity: ${({ $disabled }) => ($disabled ? 0.6 : 1)};
`

export const ListItemTitle = styled.div`
	${NotinoLabelRegular500};
	color: ${theme.color.text.primary};
`

export const ListItemDescription = styled.div`
	${NotinoLabelSmall400};
	color: ${theme.color.text.tertiary};
	margin-top: 4px;
`

export const MetaValue = styled.div`
	${NotinoLabelRegular400};
	color: ${theme.color.text.secondary};
`

export const ItemCloseButton = styled.button`
	${resetButtonStyles};
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	width: 24px;
	height: 24px;
`

export const ItemFooter = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 16px;
`

export const ItemPrice = styled(RenderPrice)<{ $disabled?: boolean }>`
	${NotinoLabelRegular500};
	color: ${theme.color.text.primary};
	opacity: ${({ $disabled }) => ($disabled ? 0.6 : 1)};
`

export const ItemEditButton = styled.button`
	${resetButtonStyles};
	${NotinoLabelRegular400};
	color: ${theme.color.text.primary};
	text-decoration: underline;

	&:hover {
		text-decoration: none;
	}
`

export const UnavailableServicesInfoBanner = styled.div`
	margin-top: 12px;

	> div {
		background: ${theme.color.background.tertiary};
		padding: 12px 14px;

		> div:nth-child(2) > div {
			color: ${theme.color.text.primary};
		}
	}
`

export const AddAnotherServiceButton = styled(Button)`
	margin-bottom: 24px;
`

export const Form = styled.form``

export const NoteSection = styled.div`
	display: flex;
	flex-direction: column;
`

export const ListItemSkeleton = styled.li`
	display: flex;
	gap: 12px;
	padding: 0 0 20px;
	margin: 0;

	&:not(:last-child) {
		border-bottom: 1px solid ${theme.color.border.divider};
		margin-bottom: 20px;
	}
`

export const ListItemSkeletonContent = styled.div`
	display: flex;
	flex: 1;
	flex-direction: column;
	gap: 10px;
	min-width: 0;
	padding-top: 2px;
`

export const ListItemSkeletonFooter = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`

export const ServiceImageSkeleton = styled(SkeletonElement)`
	width: 96px;
	height: 96px;
	flex-shrink: 0;
	border-radius: 4px;
`

export const ListItemTitleSkeleton = styled(SkeletonElement)`
	height: 14px;
	width: 38%;
	border-radius: 0;
`

export const ListItemMetaSkeleton = styled(SkeletonElement)<{ $width?: string }>`
	height: 12px;
	width: ${({ $width }) => $width || '96%'};
	border-radius: 0;
`

export const ItemPriceSkeleton = styled(SkeletonElement)`
	height: 14px;
	width: 32%;
	border-radius: 0;
`

export const ItemEditSkeleton = styled(SkeletonElement)`
	height: 14px;
	width: 28px;
	border-radius: 0;
`
